import useUserStore from '../stores/userStore';

const useAuth = () => {
  const { 
    loginFlag, 
    token, 
    userProfile, 
    logout,
    sendOTP,
    verifyOTP,
    isOTPExpired,
    clearOTPState
  } = useUserStore();

  const isAuthenticated = loginFlag && token;
  const isLoggedOut = !loginFlag || !token;

  return {
    isAuthenticated,
    isLoggedOut,
    token,
    userProfile,
    loginFlag,
    logout,
    sendOTP,
    verifyOTP,
    isOTPExpired,
    clearOTPState,
  };
};

export default useAuth;
